module.exports = __webpack_public_path__ + "static/media/volume-bonus-mobile-header-image.1ce9a542.png";